import { defaults } from 'lodash';
import {
  GetQuotesOptions,
  GetQuotesRequestBody,
  ApplianceType,
  PropertyOwner,
  Require,
  PropertyType,
} from '../types';
import { defaultGetQuotesOptions } from './constants';
import { getBoilerAgeNumber } from './getBoilerAge';

export const createGetQuotesRequestBody = (
  options: GetQuotesOptions,
): GetQuotesRequestBody => {
  const mergedOptions = defaults({}, options, defaultGetQuotesOptions);

  const {
    isAbs,
    isGuestHouse,
    isLandlord,
    isHomeRecover,
    boilerMake,
    boilerModel,
    boilerAge,
    applianceId,
    applianceType,
    promoCode,
  } = mergedOptions;

  const requestBody = {
    appliances: [
      {
        id: applianceId,
        type: applianceType,
        manufacturer:
          applianceType === ApplianceType.GASBOILER ? boilerMake : '',
        model: applianceType === ApplianceType.GASBOILER ? boilerModel : '',
        age: getBoilerAgeNumber(boilerAge),
        isUnder45kw: applianceType === ApplianceType.GASBOILER,
        naturalMainsGas: applianceType === ApplianceType.GASBOILER,
        singleBoiler: applianceType === ApplianceType.GASBOILER,
        needsRepair: isHomeRecover,
      },
    ],
    property: {
      type: isGuestHouse ? PropertyType.GUESTHOUSE : PropertyType.DOMESTIC,
      owner: isLandlord ? PropertyOwner.LANDLORD : PropertyOwner.HOMEOWNER,
    },
    requires: isAbs ? [Require.ABS] : [Require.INSURANCE],
    eligibleRewardTypes: [],
    promoCode,
  } as GetQuotesRequestBody;

  return requestBody;
};
